import React, {useEffect, useState} from 'react';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import {Grid2, Paper} from '@mui/material';
import LineChartComponent from '../components/charts/LineChartComponent';
import BarChartComponent from '../components/charts/BarChartComponent';
import PieChartComponent from '../components/charts/PieChartComponent';
import KPIComponent from "../components/charts/KPIComponent";
import RadarChartComponent from "../components/charts/RadarChartComponent";

const Dashboard = () => {
    const [loading, setLoading] = useState(true);
    const [kpis, setKPIs] = useState({});
    const [ticketsTrend, setTicketsTrend] = useState({});

    const [ticketsByIntent, setTicketsByIntent] = useState({});
    const [ticketsBySentiment, setTicketsBySentiment] = useState({});
    const [ticketStatusDistribution, setTicketStatusDistribution] = useState({});


    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await fetch(process.env.REACT_APP_BASE_URL + '/dashboard');
            if (!response.ok) throw new Error('Failed to fetch data');

            const data = await response.json();

            // Extract data from the dashboard API response
            setKPIs(data.kpis); // Set KPI data
            setTicketsTrend(data.tickets_trend); // Set tickets trend data
            setTicketsByIntent(data.tickets_by_intent); // Set tickets by intent
            setTicketsBySentiment(data.tickets_by_sentiment); // Set sentiment data
            setTicketStatusDistribution(data.ticket_status_distribution); // Set ticket status distribution
        } catch (error) {
            console.error('Error fetching dashboard data:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);


    return (
        <Container maxWidth={false} sx={{marginTop: 1, width: '100%'}}>
            <Typography variant="h4" gutterBottom>
                {/* Title here*/}
            </Typography>
            <Typography variant="subtitle1" gutterBottom>
                {/* DEscription here*/}
            </Typography>

            <Grid2 container spacing={6}>
                <Grid2 size={6}>
                    <Paper elevation={3} sx={{padding: 2}}>
                        <Typography variant="h6" gutterBottom>
                            KPIs
                        </Typography>
                        <KPIComponent data={kpis}/>
                    </Paper>
                </Grid2>
                <Grid2 size={6}>
                    <Paper elevation={3} sx={{padding: 2}}>
                        <Typography variant="h6" gutterBottom>
                            Amount of Tickets
                        </Typography>
                        <LineChartComponent data={ticketsTrend}/>
                    </Paper>
                </Grid2>
                <Grid2 size={4}>
                    <Paper elevation={3} sx={{padding: 2}}>
                        <Typography variant="h6" gutterBottom>
                            Tickets by Intent
                        </Typography>
                        <RadarChartComponent data={ticketsByIntent}/>
                    </Paper>
                </Grid2>
                <Grid2 size={4}>
                    <Paper elevation={3} sx={{padding: 2}}>
                        <Typography variant="h6" gutterBottom>
                            Tickets by Sentiment
                        </Typography>
                        <BarChartComponent data={ticketsBySentiment}/>
                    </Paper>
                </Grid2>
                <Grid2 size={4}>
                    <Paper elevation={3} sx={{padding: 2}}>
                        <Typography variant="h6" gutterBottom>
                            Ticket Status
                        </Typography>
                        <PieChartComponent data={ticketStatusDistribution}/>
                    </Paper>
                </Grid2>
            </Grid2>

        </Container>
    );
};

export default Dashboard;
